import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//@ts-ignore
import { buildURL, buildParamsForAgency } from "@utils/RESBUrlBuilder/RESB_UrlBuilder";
//@ts-ignore
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import AccessibleSelect from "@vueEntry/UIKitComponents/AccessibleSelect.vue";
import ListingTypologyMultiSelect from "@vueEntry/listingTypologyMultiSelect.vue";
import { mapState, mapActions } from "pinia";
import BaseFloatingLabel from "@vueEntry/UIKitComponents/BaseFloatingLabel.vue";
import { useCommonVars } from "@wkComposables/useCommonVars";
import { defineComponent } from "vue";
import { useSearchBeanStore } from "@store/SearchBeanStore";
export default defineComponent({
  name: "FilterRealEstateInAgency",
  components: {
    BaseFloatingLabel: BaseFloatingLabel,
    ListingTypologyMultiSelect: ListingTypologyMultiSelect,
    AccessibleSelect: AccessibleSelect,
    BaseButton: BaseButton
  },
  props: {
    showDefaultButtonSearch: {
      type: Boolean,
      "default": true
    },
    modal: {
      type: Boolean,
      required: false,
      "default": false
    }
  },
  setup: function setup() {
    var _useCommonVars = useCommonVars(),
      options = _useCommonVars.options,
      baseURL = _useCommonVars.baseURL,
      cdn = _useCommonVars.cdn;
    return {
      options: options,
      baseURL: baseURL,
      cdn: cdn
    };
  },
  data: function data() {
    return {
      hideBackdrop: false,
      positionDesktop: "",
      modalFromDesktop: false,
      typologies: null,
      typologiesIds: [],
      contractType: {
        id: "",
        label: ""
      },
      contractList: [],
      loadingSearch: false
    };
  },
  computed: Object.assign({
    labels: function labels() {
      //@ts-ignore
      return window["_labels"];
    },
    customClasses: function customClasses() {
      return "tw-h-full";
    },
    listingTypologies: function listingTypologies() {
      return this.options.listingTypologies;
    }
  }, mapState(useSearchBeanStore, ["searchBean"])),
  created: function created() {
    this.contractList.push({
      id: 0,
      label: this.labels.allTypologies
    }, {
      id: 1,
      label: this.labels.sale
    }, {
      id: 2,
      label: this.labels.rent
    }, {
      id: 3,
      label: this.labels.auction
    }, {
      id: 4,
      label: this.labels.bareOwership
    });
    this.retriveInfoFromSearchBean();
  },
  mounted: function mounted() {
    if (window.screen.width > BREAKPOINT.SMALL) {
      this.hideBackdrop = true;
      this.positionDesktop = "tw-absolute";
      this.modalFromDesktop = true;
    }
  },
  methods: Object.assign({
    searchRealEstateInAgency: function searchRealEstateInAgency() {
      var _a;
      //If no filter is chosen then return
      if (this.contractType.id == 0 && ((_a = this.searchBean.listingTypologyIdList) === null || _a === void 0 ? void 0 : _a.length) == 0) {
        return;
      }
      this.loadingSearch = true;
      if (this.contractType.id != 0) {
        this.searchBean.contractType = this.contractType.id;
        this.setContractType(this.contractType.id);
      } else {
        this.searchBean.contractType = this.contractType.id;
        this.resetContractType();
      }
      var URL = buildURL(location.pathname, "", null);
      if (URL.charAt(URL.length - 1) == "/") URL = URL.slice(0, -1);
      URL += buildParamsForAgency(this.searchBean);
      //SimoneR: Change separator symbol
      URL = URL.replace(/%2C/g, "&");
      window.location.href = this.baseURL + URL;
    },
    resetContractType: function resetContractType() {
      this.updateSearchBean({
        sale: false,
        rent: false,
        auctionType: 0,
        bareOwnershipType: 0
      });
    },
    /**
     * Retrive info for filling the filter, with the filter insert before the reloading the page by the uer
     * */
    retriveInfoFromSearchBean: function retriveInfoFromSearchBean() {
      this.setContractTypeFromSearchBean(this.searchBean);
    },
    /**
     * Reset the fields used inside the agency filter inside the search bean
     * */
    setContractType: function setContractType(type) {
      var _this = this;
      var _a;
      /**
       * 1 stands for Sale
       * 2 stands for Rent
       * 3 stands for Auction
       * 4 stands for Bare ownership
       * **/
      var types = {
        1: function _() {
          return _this.updateSearchBean({
            sale: true,
            rent: false,
            auctionType: 0,
            bareOwnershipType: 0
          });
        },
        2: function _() {
          return _this.updateSearchBean({
            sale: false,
            rent: true,
            auctionType: 0,
            bareOwnershipType: 0
          });
        },
        3: function _() {
          return _this.updateSearchBean({
            sale: false,
            rent: false,
            auctionType: 1,
            bareOwnershipType: 0
          });
        },
        4: function _() {
          return _this.updateSearchBean({
            sale: false,
            rent: false,
            auctionType: 0,
            bareOwnershipType: 1
          });
        }
      };
      return (_a = types[type]) === null || _a === void 0 ? void 0 : _a.call(types);
    },
    getOptions: function getOptions(key) {
      //@ts-ignore
      return window["_options"][key];
    },
    setContractTypeFromSearchBean: function setContractTypeFromSearchBean(searchBean) {
      if (searchBean === null || searchBean === void 0 ? void 0 : searchBean.sale) {
        this.contractType.id = this.contractList[1].id;
        this.contractType.label = this.contractList[1].label;
      } else if (searchBean === null || searchBean === void 0 ? void 0 : searchBean.rent) {
        this.contractType.id = this.contractList[2].id;
        this.contractType.label = this.contractList[2].label;
      } else if (searchBean === null || searchBean === void 0 ? void 0 : searchBean.auctionType) {
        this.contractType.id = this.contractList[3].id;
        this.contractType.label = this.contractList[3].label;
      } else if (searchBean === null || searchBean === void 0 ? void 0 : searchBean.bareOwnershipType) {
        this.contractType.id = this.contractList[4].id;
        this.contractType.label = this.contractList[4].label;
      } else {
        this.contractType.id = this.contractList[0].id;
        this.contractType.label = this.contractList[0].label;
      }
    },
    onLTMSChange: function onLTMSChange(option) {
      this.updateSearchBean({
        macroTypologyId: option.macroTypologyID,
        macroTypologyIdList: option.macroTypologyIdList,
        listingTypologyURL: option.url,
        listingTypologyId: option.listingTypologyId,
        listingTypologyIdList: option.selectedListingTypologiesIDList,
        typologyIdList: option.selectedTypologiesIDList
      });
    }
  }, mapActions(useSearchBeanStore, ["updateSearchBean"]))
});